var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.22168 1.65465H18.4837C20.3033 1.65465 21.7783 3.03328 21.7783 5.05451V20.4271C21.7783 22.1609 19.3457 23.0018 17.9825 21.7393L13.5089 18.329L9.0353 21.7393C7.67204 23.0018 5.23946 22.1611 5.23946 20.4274V7.91008C5.23946 1.51735 2.22168 1.65465 2.22168 1.65465Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkLine);
export default __webpack_public_path__ + "static/media/bookmark_line.1a5d3a3fb2b2878ff87c08df0fe32b7a.svg";
export { ForwardRef as ReactComponent };